import { render } from "./LungCancerSampleView.vue?vue&type=template&id=70011e2d"
import script from "./LungCancerSampleView.vue?vue&type=script&lang=js"
export * from "./LungCancerSampleView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__